import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import App from 'App';
import { Provider } from 'react-redux';
import { store } from 'data';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { PrimeReactProvider } from 'primereact/api';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
	<PrimeReactProvider value={{ ripple: false }}>
		<Provider store={store}>
			<App />
		</Provider>
	</PrimeReactProvider>,
);
